export const PHASE2_DOC_TYPES = [
  "AADHARCARD",
  "PANCARD",
  "PPSIZEPHOTO",
  "METRIC",
  "HIGHERSECONDARY",
  "BACHELOR_DEGREE",
  "MASTER_DEGREE",
  "EXPCERTIFICATE",
] as const;

export type Phase2DocType = (typeof PHASE2_DOC_TYPES)[number];

/** Selected files per backend doc type (in-memory until upload). */
export type DocumentFilesState = Partial<Record<Phase2DocType, File | null>>;

export type Phase2DocSlot = {
  docType: Phase2DocType;
  label: string;
  required: boolean;
};

/** Order matches upload sequence after required docs first. */
export const PHASE2_DOC_SLOTS: Phase2DocSlot[] = [
  { docType: "AADHARCARD", label: "Aadhaar Card Copy", required: true },
  { docType: "PANCARD", label: "PAN Card Copy", required: true },
  { docType: "PPSIZEPHOTO", label: "Passport-Size Photograph", required: true },
  { docType: "METRIC", label: "10th Marksheet", required: true },
  { docType: "HIGHERSECONDARY", label: "12th Marksheet", required: true },
  { docType: "BACHELOR_DEGREE", label: "Bachelor’s Degree", required: false },
  { docType: "MASTER_DEGREE", label: "Master’s Degree", required: false },
  { docType: "EXPCERTIFICATE", label: "Experience Letter", required: false },
];
